    <!-- <button class="button btn-success upload-button" (click)="selectFileElement.click()">
      <i class="fa fa-folder"></i> Select file
      <input #selectFileElement style="display: none" multiple type="file" (change)="selectFile($event)" />
    </button> -->
    <div class="row" style="margin-top: 13px;">
      <div class="col-9" style="padding: 0px">
        <div class="dropzonecontainer" appDnd (fileDropped)="onFileDropped($event)" >
          <input type="file" id="fileDropRef" multiple #selectFileElement multiple type="file"
            (change)="selectFile($event)" accept=".pdf,.tif,.jpg"/>
          <i class="fa fa-upload" style="font-size: 16px"></i>

          <h6>Drag and drop files here</h6>
          <h6>or</h6>
          <label for="fileDropRef">Browse for files</label>
        </div>
      </div>
      <div class="col-3">
        <div class="scrollable">
          <div class="alert alert-light" style="font-size: 12px;
          font-weight: bold; text-align: left"
            *ngFor="let selectedFile of selectedFiles; let selectedFileIndex = index ">
            <i class="fa fa-folder" style="color: rgb(223, 171, 61)"></i> {{selectedFile?.name}}
            <i class="fa fa-trash" style="color: rgb(223, 85, 61)"></i>
          </div>
        </div>
        
        <div *ngIf="currentFile" class="progress" style="margin-top: 14px; height: 7px;">
          <div class="progress-bar progress-bar-info " *ngIf="progress && progress" role="progressbar"
            attr.aria-valuenow="{{ progress }}" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{ width: progress + '%' }">
            <!-- {{ progress }}% -->
          </div>
        </div>
        <div>
        {{ message }}
        </div>

        <label class="btn btn-default">
          <button class="button btn-success upload-button" [disabled]="!selectedFiles" (click)="upload()">
            <i class="fa fa-upload"></i> Upload
          </button>
        </label>
        
      </div>
    </div>



<!-- <div class="card">
  <div class="card-header">List of Files</div>
  <ul class="list-group list-group-flush" *ngFor="let file of fileInfos | async">
    <li class="list-group-item">
      <a href="{{ file.url }}">{{ file.name }}</a>
    </li>
  </ul>
</div> -->